import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=bd07dc8e&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd07dc8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd07dc8e')) {
      api.createRecord('bd07dc8e', component.options)
    } else {
      api.reload('bd07dc8e', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=bd07dc8e&scoped=true&", function () {
      api.rerender('bd07dc8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Account.vue"
export default component.exports